import React from 'react';
import { defineMessages } from 'react-intl';
import { Link } from 'react-router-dom';

import { SubscriptionLimitWouldBeExceeded, ActiveSubscriptionRequired } from '../code-constants';

// defineMessages will strip anything that is not an id, defaultMessage, or description prop
const messageValues = {
  [SubscriptionLimitWouldBeExceeded]: {
    a: (chunks) => <Link to='/settings/payments'>{chunks}</Link>,
  },
};

export const messages = defineMessages({
  [ActiveSubscriptionRequired]: {
    description: 'errors.subscription.inactive',
    defaultMessage: 'An active subscription is required.',
    id: 'P0adHI',
  },
  [SubscriptionLimitWouldBeExceeded]: {
    description: 'errors.subscription.limitExceeded',
    defaultMessage:
      'This shipment would exceed your subscription limit for this billing period. To continue shipping before your billing period resets, please <a>upgrade your subscription</a>.',
    id: 'ntwRtL',
  },
});

export const subscriptionError = ({ code }) => {
  const message = messages[code];
  const values = messageValues[code];
  return {
    ...message,
    values,
  };
};
